var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _g, _path26;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDeleteCard(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 113,
    viewBox: "0 0 128 113",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M115.754 61.806C115.754 89.4462 93.3466 111.854 65.7064 111.854C38.0661 111.854 15.6592 89.4462 15.6592 61.806C15.6592 34.1657 38.0661 11.7583 65.7064 11.7583C93.3466 11.7583 115.754 34.1657 115.754 61.806Z",
    stroke: "#C4C3C3",
    strokeWidth: 0.672854,
    strokeDasharray: "3.38 3.38"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M102.868 61.8063C102.868 82.3321 86.2286 98.9719 65.7028 98.9719C45.1764 98.9719 28.5376 82.3321 28.5376 61.8063C28.5376 41.2804 45.1764 24.6406 65.7028 24.6406C86.2286 24.6406 102.868 41.2804 102.868 61.8063Z",
    stroke: "#C4C3C3",
    strokeWidth: 0.672854,
    strokeDasharray: "3.39 3.39"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.20069 68.5446L5.27148 68.5161",
    stroke: "#D2D8DF",
    strokeWidth: 0.672854,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.53261 66.7822L4.86621 67.4047",
    stroke: "#D2D8DF",
    strokeWidth: 0.672854,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M3.79475 65.9775L3.78076 66.886",
    stroke: "#D2D8DF",
    strokeWidth: 0.672854,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M2.00098 66.6016L2.64809 67.2641",
    stroke: "#D2D8DF",
    strokeWidth: 0.672854,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M1.21045 68.2886L2.13917 68.317",
    stroke: "#D2D8DF",
    strokeWidth: 0.672854,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M1.88428 70.0507L2.55116 69.4282",
    stroke: "#D2D8DF",
    strokeWidth: 0.672854,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M3.6123 70.8548L3.62629 69.9463",
    stroke: "#D2D8DF",
    strokeWidth: 0.672854,
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M5.40786 70.2309L4.76074 69.5684",
    stroke: "#D2D8DF",
    strokeWidth: 0.672854,
    strokeLinecap: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M127.383 55.5918L126.975 56.034",
    stroke: "#D2D8DF",
    strokeWidth: 0.672854,
    strokeLinecap: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M125.458 55.9766L125.766 56.2606",
    stroke: "#D2D8DF",
    strokeWidth: 0.672854,
    strokeLinecap: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M125.147 57.9363L125.555 57.4941",
    stroke: "#D2D8DF",
    strokeWidth: 0.672854,
    strokeLinecap: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M127.066 57.5516L126.759 57.2676",
    stroke: "#D2D8DF",
    strokeWidth: 0.672854,
    strokeLinecap: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M89.9744 3.62222L88.9863 3.5957",
    stroke: "#D2D8DF",
    strokeWidth: 0.672854,
    strokeLinecap: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M87.4153 1.2373L87.4004 2.08164",
    stroke: "#D2D8DF",
    strokeWidth: 0.672854,
    strokeLinecap: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M84.6611 3.38525L85.6492 3.41129",
    stroke: "#D2D8DF",
    strokeWidth: 0.672854,
    strokeLinecap: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M87.2212 5.7706L87.2361 4.92627",
    stroke: "#D2D8DF",
    strokeWidth: 0.672854,
    strokeLinecap: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.8009 94.7873C16.0901 95 14.9063 96.0444 14.5013 97.2827C14.4333 96.1322 13.7028 94.686 12.8989 94.4777C13.8797 94.131 14.942 92.8566 15.2246 91.7827C15.1735 92.9082 16.1953 94.5424 16.8009 94.7873Z",
    fill: "#D8D8D8"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.45 8.14535C32.9018 8.24227 31.9301 8.91735 31.5212 9.8046C31.5699 8.94195 31.1509 7.80154 30.5703 7.57683C31.3307 7.40324 32.2325 6.54589 32.5358 5.77051C32.4003 6.60472 33.0199 7.91052 33.45 8.14535Z",
    fill: "#D8D8D8"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M106.117 14.4093C105.384 14.3934 104.804 13.7872 104.82 13.0553C104.836 12.3233 105.442 11.7427 106.174 11.7586C106.906 11.7745 107.487 12.3807 107.471 13.1126C107.454 13.8446 106.849 14.4252 106.117 14.4093Z",
    fill: "#D1D9E0"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M106.123 101.28C105.486 101.266 104.98 100.738 104.994 100.101C105.007 99.4638 105.535 98.9584 106.173 98.9719C106.81 98.9859 107.316 99.5135 107.302 100.151C107.288 100.788 106.76 101.294 106.123 101.28Z",
    fill: "#D8D8D8"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.2843 32.0036C9.88989 31.9949 9.57695 31.6685 9.58563 31.2736C9.59382 30.8791 9.92076 30.5667 10.3152 30.5749C10.7096 30.5835 11.0226 30.91 11.0144 31.3044C11.0057 31.6994 10.6788 32.0123 10.2843 32.0036Z",
    stroke: "#D2D8DF",
    strokeWidth: 0.672854,
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_9601_39",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 57,
    y: 53,
    width: 18,
    height: 14
  }, _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M68.0095 53.1001H64.6341C61.4519 53.1001 59.8604 53.1001 58.8723 54.0891C58.1601 54.8005 57.9609 55.8249 57.9052 57.5303H74.7383C74.6826 55.8249 74.4835 54.8005 73.7713 54.0891C72.7831 53.1001 71.1916 53.1001 68.0095 53.1001ZM64.6341 66.6017H68.0095C71.1916 66.6017 72.7831 66.6017 73.7713 65.6127C74.7603 64.6245 74.7603 63.033 74.7603 59.8509C74.7603 59.4779 74.7603 59.1269 74.7586 58.7961H57.885C57.8833 59.1269 57.8833 59.4779 57.8833 59.8509C57.8833 63.033 57.8833 64.6245 58.8723 65.6127C59.8604 66.6017 61.4519 66.6017 64.6341 66.6017Z",
    fill: "white"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.626 63.2261C60.626 63.0583 60.6927 62.8973 60.8113 62.7786C60.93 62.6599 61.091 62.5933 61.2589 62.5933H64.6343C64.8021 62.5933 64.9631 62.6599 65.0818 62.7786C65.2005 62.8973 65.2671 63.0583 65.2671 63.2261C65.2671 63.394 65.2005 63.555 65.0818 63.6737C64.9631 63.7924 64.8021 63.859 64.6343 63.859H61.2589C61.091 63.859 60.93 63.7924 60.8113 63.6737C60.6927 63.555 60.626 63.394 60.626 63.2261ZM66.111 63.2261C66.111 63.0583 66.1777 62.8973 66.2964 62.7786C66.415 62.6599 66.576 62.5933 66.7439 62.5933H68.0096C68.1775 62.5933 68.3385 62.6599 68.4572 62.7786C68.5759 62.8973 68.6425 63.0583 68.6425 63.2261C68.6425 63.394 68.5759 63.555 68.4572 63.6737C68.3385 63.7924 68.1775 63.859 68.0096 63.859H66.7439C66.576 63.859 66.415 63.7924 66.2964 63.6737C66.1777 63.555 66.111 63.394 66.111 63.2261Z",
    fill: "black"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_9601_39)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M56.1958 49.7246H76.4481V69.977H56.1958V49.7246Z",
    fill: "#333333"
  }))), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M79.1092 61.1592C79.2534 61.1592 79.3917 61.2165 79.4936 61.3184C79.5956 61.4204 79.6528 61.5586 79.6528 61.7028C79.6528 61.847 79.5956 61.9852 79.4936 62.0872C79.3917 62.1891 79.2534 62.2464 79.1092 62.2464H78.5656L78.564 62.285L78.0568 69.3907C78.0372 69.665 77.9145 69.9217 77.7133 70.1091C77.512 70.2965 77.2472 70.4007 76.9722 70.4007H72.5477C72.2727 70.4007 72.0079 70.2965 71.8067 70.1091C71.6055 69.9217 71.4827 69.665 71.4632 69.3907L70.956 62.2856C70.9552 62.2725 70.9548 62.2595 70.9549 62.2464H70.4113C70.2671 62.2464 70.1288 62.1891 70.0269 62.0872C69.9249 61.9852 69.8677 61.847 69.8677 61.7028C69.8677 61.5586 69.9249 61.4204 70.0269 61.3184C70.1288 61.2165 70.2671 61.1592 70.4113 61.1592H79.1092ZM75.8475 59.5283C75.9917 59.5283 76.1299 59.5856 76.2319 59.6875C76.3338 59.7895 76.3911 59.9278 76.3911 60.0719C76.3911 60.2161 76.3338 60.3544 76.2319 60.4563C76.1299 60.5583 75.9917 60.6156 75.8475 60.6156H73.673C73.5288 60.6156 73.3906 60.5583 73.2886 60.4563C73.1867 60.3544 73.1294 60.2161 73.1294 60.0719C73.1294 59.9278 73.1867 59.7895 73.2886 59.6875C73.3906 59.5856 73.5288 59.5283 73.673 59.5283H75.8475Z",
    fill: "#FF0000"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteCard);
export default __webpack_public_path__ + "static/media/delete_card.d41c255d653bf931992f2138c019525a.svg";
export { ForwardRef as ReactComponent };